import { useTranslations } from 'next-intl';
import { SEARCH_EMPTY_ICON } from '@/app/constants';
import { cn } from '@/app/utils';

interface SearchEmptyProps {
  emptyText?: string;
  emptySrc?: string;
  textClassName?: string;
  actionText?: string;
  onAction?: () => void;
}

export const SearchEmpty = ({
  emptyText,
  emptySrc = SEARCH_EMPTY_ICON.feed,
  textClassName,
  actionText,
  onAction,
}: SearchEmptyProps) => {
  const t = useTranslations();
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <img src={emptySrc} alt="search_empty" className="h-[140px] w-[180px]" />
      <div className={cn('mt-2 p-2.5 text-base text-system-text01/70', textClassName)}>
        {emptyText ?? t('creations.warning.noFilterResult')}
      </div>
      {actionText && onAction && (
        <button
          type="button"
          className="mt-2 h-9 rounded-full bg-ShengshuButton px-5 font-semibold text-black hover:bg-ShengshuButtonHover"
          onClick={onAction}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};
